import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";

/** @jsxImportSource @emotion/react */
import { Typography } from "@vc-workspace/utils-typography";
import { containerStyles, contentItemContainer, contentItemImage, contentContainer } from './maker-why-vibecity.module.style';
export function MakerWhyVibecity(props) {
  return _jsxs("div", {
    css: containerStyles,
    children: [_jsx(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "night_rider",
      className: "text-center",
      bold: true,
      children: "Welcome to Vibecity!"
    }), _jsx(Typography, {
      type: props.context.isMobileView ? "Headline_H1" : "Heading2",
      color: "night_rider",
      className: "text-center",
      bold: true,
      children: "The Handmade Marketplace"
    }), _jsx("div", {
      className: "page-container",
      children: _jsxs("div", {
        css: contentContainer,
        children: [_jsxs("div", {
          css: contentItemContainer,
          children: [_jsx("img", {
            src: "/_mp-images/reach_people.png",
            css: contentItemImage
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Reach lakhs of people"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body2" : "Headline_H3",
              color: "heavy_metal",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "Connect with excited customers to sell through Vibecity Marketplace & your Vibecity Shop"
            })]
          })]
        }), _jsxs("div", {
          css: contentItemContainer,
          children: [_jsx("img", {
            src: "/_mp-images/sell_easy.png",
            css: contentItemImage
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Sell without any headache"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body2" : "Headline_H3",
              color: "heavy_metal",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "Start listing & sell your products in just minutes"
            })]
          })]
        }), _jsxs("div", {
          css: contentItemContainer,
          children: [_jsx("img", {
            src: "/_mp-images/sell_for_growth.png",
            css: contentItemImage
          }), _jsxs("div", {
            className: props.context.isMobileView ? "pl-6" : "",
            children: [_jsx(Typography, {
              type: props.context.isMobileView ? "Headline_H3" : "Headline_H1",
              color: "heavy_metal",
              className: props.context.isMobileView ? "" : "pt-4",
              bold: true,
              children: "Your growth is our mission!"
            }), _jsx(Typography, {
              type: props.context.isMobileView ? "Body2" : "Headline_H3",
              color: "heavy_metal",
              className: props.context.isMobileView ? "pt-1" : "pt-4",
              children: "Vibecity\u2019s Community, Tools & Support Team are all here to help you grow"
            })]
          })]
        })]
      })
    })]
  });
}
export default MakerWhyVibecity;